import { Plugin } from "@ckeditor/ckeditor5-core"
import { ReleaseNotesCommand } from "./releasenotescommand";
import { ReleaseNotesUI } from "./releasenotesui";


import { CkeditorConstants } from '../../src/utils/ckeditorconstants';

const {
    PLUGINS: { RELEASE_NOTES }
} = CkeditorConstants

export default class ReleaseNotes extends Plugin {
    static get pluginName() {
        return "ReleaseNotes";
    }

    static get requires() {
        return [ReleaseNotesUI, ReleaseNotesCommand];
    }

    init() {
        const editor = this.editor;
        editor.commands.add(
            RELEASE_NOTES,
            new ReleaseNotesCommand(editor)
        );
        this.isEnabled = true;
    }
}